import moment from 'moment';
import linkifyHtml from 'linkify-html';

export const mediaSize = (size: number | undefined) : string => {
  if (!size) {
    return 'N/A';
  }
  if (size < 1024) {
    return `${size} B`;
  }
  if (size < 1024 * 1024) {
    const sizeInKB = (size / 1024).toFixed(2);
    return `${sizeInKB} KB`;
  }
  const sizeInMB = (size / (1024 * 1024)).toFixed(2);
  return `${sizeInMB} MB`;
};

// eslint-disable-next-line no-bitwise
export const fileType = (filename: string): string => filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2).toUpperCase();

export const createdDate = (date: number, fomat: string): string => moment(new Date(date)).format(fomat);

export const descriptionWithLink = (data: string, isMessage = false) => {
  try {
    const linkData = linkifyHtml(data, {
      defaultProtocol: 'https',
      attributes: {
        target: '_blank',
        class: isMessage ? 'a-linkify message' : 'a-linkify',
      },
    });
    const phoneRegex = /(?!(?:[^<]*?\bhref\s*=\s*["'][^"']*?))(?<!<a[^>]*>.*?)(\+\d{1,3}\s?)?(\d{1,4}[\s-]?)?\(?\d{2,4}\)?[\s.-]?\d{1,4}[\s.-]?\d{2,4}[\s.-]?\d{2,4}(?![^<]*<\/a>)/g;
    const formattedText = linkData.replace(phoneRegex, (match) => `<a href="tel:${match}" class="a-linkify ${isMessage ? 'a-linkify message' : 'a-linkify'}">${match}</a>`);
    return formattedText;
  } catch (err) {
    return data;
  }
};
